module.exports = __webpack_public_path__ + "img/emptyFolder.4461e81d.jpg";